import { render, staticRenderFns } from "./my-issue-topic.vue?vue&type=template&id=ad1baa52&scoped=true&"
import script from "./my-issue-topic.vue?vue&type=script&lang=js&"
export * from "./my-issue-topic.vue?vue&type=script&lang=js&"
import style0 from "./my-issue-topic.vue?vue&type=style&index=0&id=ad1baa52&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad1baa52",
  null
  
)

export default component.exports